
export enum APPLICATION_STATUS {
  STATUS_NEW = 'Новая заявка',
  STATUS_IN_PROGRESS = 'В работе',
  STATUS_ISSUED = 'Выдана',
  STATUS_REJECTED = 'Отказ',
  STATUS_AWAITING_ISSUANCE = 'Ожидается выдача',
  STATUS_DRAFT = 'Черновик',
  STATUS_UNDER_REVISION = 'На доработке',
  STATUS_PROPOSAL = 'Предложение',
  STATUS_CLIENT_REJECTED = 'Отказано клиенту',
  STATUS_SIGNATURE_REQUIRED = 'Требуется подписание',
  STATUS_PAYMENT_REQUIRED = 'Требуется оплата',
  STATUS_UNDER_REVIEW = 'На рассмотрении',
  STATUS_RETURNED_FOR_REVISION = 'Возвращено на доработку',
  STATUS_RELEASED = 'Выпущена',
};
